import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA79ACtbvYBGpMF7E-PFT19sSjBnTvUsfc",
  authDomain: "simpro-89eef.firebaseapp.com",
  projectId: "simpro-89eef",
  storageBucket: "simpro-89eef.firebasestorage.app",
  messagingSenderId: "883777691353",
  appId: "1:883777691353:web:51b5546b9829af7e63e8c8"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 